import { useMemo } from "react";
import uuid from "../../../mixins/uuid";
export default (function (describedby) { return useMemo(function () { return describedby || uuid(); }, []); });
